import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MeilleursBiensService } from 'app/services/meilleuresBiens/meilleurs-biens.service';

@Component({
  selector: 'app-meilleurs-bien-sfax',
  templateUrl: './meilleurs-bien-sfax.component.html',
  styleUrls: ['./meilleurs-bien-sfax.component.scss']
})
export class MeilleursBienSfaxComponent implements OnInit {

  public MeilleursBiens: any
  p: Number = 1;
  dataSource = new MatTableDataSource();

  constructor(private meilleursBiensService: MeilleursBiensService) { }
 ngOnInit(): void {
  this.getMeilleursBiensSfax();
     
  }
  getMeilleursBiensSfax() {
    this.meilleursBiensService.getMeilleursBiensSfax().subscribe((data: any) => {
    
      this.MeilleursBiens = data;
     
        console.log('meilleurs biens sfax',this.MeilleursBiens)
         

    })
  }

  


  SupprimerMeilleursBiens(MeilleursBiens: any) {
    this.meilleursBiensService.deleteMeilleursBiens(MeilleursBiens.id).subscribe((response: any) => {


      console.log(this.dataSource.data);


    });
 

  }

}
